// extracted by mini-css-extract-plugin
export default {"welcomeSection":"style_welcomeSection__uQbPb","container":"style_container__VqIS6","logo":"style_logo__1y-y7","text":"style_text__NAzlj"};